import { actionTypes } from 'app/types/action_types';

const initialState = {
  carouselAssets: [],
  displayAssets: [],
  fmaInfo: {},
  hideCarousel: false,
};

const initialize = (state, payload) => ({
  ...state,
  carouselAssets: payload.carouselAssets || state.carouselAssets,
  displayAssets: payload.displayAssets || state.displayAssets,
  fmaInfo: payload.fmaInfo || state.fmaInfo,
  hideCarousel: payload.hideCarousel || state.hideCarousel,
});

// eslint-disable-next-line default-param-last
const creativeImageHomeReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.INITIALIZE:
      return initialize(state, action.payload);
    default:
      return state;
  }
};

export default creativeImageHomeReducer;
